var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full mx-auto py-8"},[(_vm.$usesFeature('classic-jobs'))?_c('CandidateList'):_vm._e(),(_vm.$usesFeature('candidate-wizard'))?_c('CandidatesList'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }